<div class="page-header">User Management</div>

<form [formGroup]="manageUser" class="mb-3">
    <div class="row dual-group align-items-center">
        <strong>Payment Dual Authorization:</strong>&nbsp;&nbsp;
        <mat-radio-group formControlName="dualAuthorization">
            <mat-radio-button class="example-radio-button" [value]="true" disableRipple>
                On
            </mat-radio-button>
            <mat-radio-button class="example-radio-button" [value]="false" disableRipple>
                Off
            </mat-radio-button>
        </mat-radio-group>
        <strong class="ml-5">Transfer Dual Authorization:</strong>&nbsp;&nbsp;
        <mat-radio-group formControlName="transferDualAuthorization">
            <mat-radio-button class="example-radio-button" [value]="true" disableRipple>
                On
            </mat-radio-button>
            <mat-radio-button class="example-radio-button" [value]="false" disableRipple>
                Off
            </mat-radio-button>
        </mat-radio-group>

        <div class="ml-auto d-md-block d-none">
            <button class="btn btn-block btn-greengo btn-lg btn-custom-height" (click)="updateUserRole()" npFocusOutClicked>
                Save
            </button>
        </div>&nbsp;&nbsp;
        <button class="btn-custom-height btn btn-block btn-greengo-o btn-lg d-md-block d-none" (click)="getManagementData()" npFocusOutClicked>
            Refresh
        </button>
    </div>
</form>

<ng-container *ngIf="!isLoading">
    <div class="manage-user-table">
        <ng-table [rows]="rows" [columns]="columns" (selectionChanged)="changeUserRole($event)">
        </ng-table>
    </div>
</ng-container>

<div class="row form-group d-md-none pt-4">
    <div class="col-6">
        <button class="btn btn-block btn-greengo btn-lg" (click)="updateUserRole()" npFocusOutClicked>
            Save
        </button>
    </div>
    <div class="col-6">
        <button class="btn btn-block btn-greengo-o btn-lg" (click)="getManagementData()" npFocusOutClicked>
            Refresh
        </button>
    </div>
</div>